export function appendHashToUrl (hash: string, url: string): string {
  return (url.indexOf('?') === -1 ? '?' : '&') + 'hash=' + hash;
}